// --------------------------------------------------------------------------------
// import React, {
//   createContext,
//   useEffect,
//   useState,
//   useCallback,
//   useMemo,
// } from "react";
// import Cookies from "js-cookie";
// import { AdminDetails } from "./apis/admin/index";
// import {
//   Settings,
//   AllGames,
//   AllLiveMarketsData,
//   OnlyLiveGamesMatches,
//   MarketAnalysisLiveGamesMatches,
// } from "./apis/common/index";
// import { CookiesName } from "./common";
// import { io } from "socket.io-client";
// import { GetAll, GetAllUnmatchBets } from "./apis/admin/profile/bets";

// export const Context = createContext();

// const AppContext = ({ children }) => {
//   // Use environment variables for different environments
//   // const IMG_URL = "http://127.0.0.1:5555";
//   // const SOCKET = "ws://127.0.0.1:5555";

//   // const IMG_URL = "http://192.168.16.53:5555";
//   // const SOCKET = "ws://192.168.16.53:5555";

//   // const IMG_URL = "http://192.168.1.73:5555";
//   // const SOCKET = "ws://192.168.1.73:5555";

//   // const IMG_URL = "http://start555node.profcyma.org:5555";
//   // const SOCKET = "ws://start555node.profcyma.org:5555";

//   // const IMG_URL = "https://start555node.profcyma.org:5555";
//   // const SOCKET = "wss://start555node.profcyma.org:5555";

//   // # # Production Environment Variable
//   const IMG_URL = "https://node.star555.in";
//   const SOCKET = "wss://node.star555.in";

//   const [ChangePass, setChangePass] = useState(false);
//   const [User, setUser] = useState({});
//   const [LiveAmount, setLiveAmount] = useState([]);
//   const [AppSetup, setAppSetup] = useState({});
//   const [Games, setGames] = useState([]);
//   const [Markets, setMarkets] = useState([]);
//   const [Fancy, setFancy] = useState([]);
//   const [Scorecard, setScorecard] = useState({});
//   const [BallEvent, setBallEvent] = useState({});
//   const [LiveGamesMatches, setLiveGamesMatches] = useState([]);
//   const [
//     MarketAnalysisLiveGamesMatche,
//     setMarketAnalysisLiveGamesMatches,
//   ] = useState([]);
//   const [socket, setSocket] = useState(null);
//   const [matched_bets, setmatched_bets] = useState([]);
//   const [unmatched_bets, setunmatched_bets] = useState([]);

//   // Memoize the token check
//   const token = useMemo(() => Cookies.get(CookiesName), []);

//   // Socket connection
//   useEffect(() => {
//     const newSocket = io(SOCKET, {
//       reconnection: true,
//       reconnectionAttempts: 5,
//       reconnectionDelay: 1000,
//       transports: ["websocket"],
//     });

//     setSocket(newSocket);

//     newSocket.on("connect", () => {
//       console.log("Connected to WebSocket server");
//     });

//     newSocket.on("matchodds", setMarkets);
//     newSocket.on("fancyodds", setFancy);
//     newSocket.on("ball_event", setBallEvent);

//     // Optional: Add scorecard listener if needed
//     // newSocket.on("scorecard", setScorecard);

//     newSocket.on("disconnect", () => {
//       console.log("Disconnected from WebSocket server");
//     });

//     newSocket.on("connect_error", (error) => {
//       console.error("Connection error:", error);
//     });

//     newSocket.on("error", (error) => {
//       console.error("WebSocket error:", error);
//     });

//     return () => {
//       newSocket.disconnect();
//     };
//   }, [SOCKET]);

//   // Memoize API calls to prevent unnecessary re-renders
//   const GETUser = useCallback(async () => {
//     if (!token) return;

//     try {
//       const response = await AdminDetails();
//       if (response?.success) {
//         setChangePass(response?.data?.user_details?.change_password);
//         setUser(response?.data);
//       }
//     } catch (error) {
//       console.error("Error fetching user:", error);
//     }
//   }, [token]);

//   const GETSettings = useCallback(async () => {
//     try {
//       const response = await Settings();
//       if (response?.success) {
//         setAppSetup(response?.data);
//       }
//     } catch (error) {
//       console.error("Error fetching settings:", error);
//     }
//   }, []);

//   const GETAllGames = useCallback(async () => {
//     try {
//       const response = await AllGames();
//       if (response?.success) {
//         setGames(response?.data);
//       }
//     } catch (error) {
//       console.error("Error fetching games:", error);
//     }
//   }, []);

//   const GETOnlyLiveGamesMatches = useCallback(async () => {
//     try {
//       const [liveResponse, analysisResponse] = await Promise.all([
//         OnlyLiveGamesMatches(),
//         MarketAnalysisLiveGamesMatches(),
//       ]);

//       if (liveResponse?.success) {
//         setLiveGamesMatches(liveResponse?.data);
//       }
//       if (analysisResponse?.success) {
//         setMarketAnalysisLiveGamesMatches(analysisResponse?.data);
//       }
//     } catch (error) {
//       console.error("Error fetching live matches:", error);
//     }
//   }, []);

//   const GetData = useCallback(async () => {
//     if (!User?.user_details?.id) return;

//     try {
//       const [matched, unmatched] = await Promise.all([
//         GetAll(),
//         GetAllUnmatchBets(),
//       ]);
//       setmatched_bets(matched.data);
//       setunmatched_bets(unmatched.data);
//     } catch (error) {
//       console.error("Error fetching bets:", error);
//     }
//   }, [User?.user_details?.id]);

//   // Initial data fetching
//   useEffect(() => {
//     GETUser();
//     GETSettings();
//     GETAllGames();
//     GETOnlyLiveGamesMatches();
//   }, [GETUser, GETSettings, GETAllGames, GETOnlyLiveGamesMatches]);

//   // Polling intervals
//   useEffect(() => {
//     const userInterval = setInterval(GETUser, 3000);
//     const gamesInterval = setInterval(GETAllGames, 10000);
//     const liveMatchesInterval = setInterval(GETOnlyLiveGamesMatches, 10000);

//     return () => {
//       clearInterval(userInterval);
//       clearInterval(gamesInterval);
//       clearInterval(liveMatchesInterval);
//     };
//   }, [GETUser, GETAllGames, GETOnlyLiveGamesMatches]);

//   // Fetch bets when user is available
//   useEffect(() => {
//     if (User?.user_details?.id) {
//       GetData();
//     }
//   }, [User, GetData]);

//   // Memoize context value to prevent unnecessary re-renders
//   const contextValue = useMemo(
//     () => ({
//       IMG_URL,
//       Cookies,
//       AppSetup,
//       User,
//       setUser,
//       GETUser,
//       Games,
//       Markets,
//       Fancy,
//       LiveGamesMatches,
//       MarketAnalysisLiveGamesMatche,
//       Scorecard,
//       LiveAmount,
//       setLiveAmount,
//       BallEvent,
//       ChangePass,
//       setChangePass,
//       matched_bets,
//       unmatched_bets,
//     }),
//     [
//       IMG_URL,
//       AppSetup,
//       User,
//       Games,
//       Markets,
//       Fancy,
//       LiveGamesMatches,
//       MarketAnalysisLiveGamesMatche,
//       Scorecard,
//       LiveAmount,
//       BallEvent,
//       ChangePass,
//       matched_bets,
//       unmatched_bets,
//     ],
//   );

//   return <Context.Provider value={contextValue}>{children}</Context.Provider>;
// };

// export default AppContext;
// --------------------------------------------------------------------------------
import React, {
  createContext,
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import Cookies from "js-cookie";
import { AdminDetails } from "./apis/admin/index";
import {
  Settings,
  AllGames,
  AllLiveMarketsData,
  OnlyLiveGamesMatches,
  MarketAnalysisLiveGamesMatches,
} from "./apis/common/index";
import { CookiesName } from "./common";
import { io } from "socket.io-client";
import { GetAll, GetAllUnmatchBets } from "./apis/admin/profile/bets";
import { ManageSettlementList } from "./apis/admin/profile/settlement";

// Create context with undefined initial value for better type checking
export const Context = createContext(undefined);

// Custom hook for socket connection
const useSocketConnection = (socketUrl) => {
  const [markets, setMarkets] = useState([]);
  const [fancy, setFancy] = useState([]);
  const [ballEvent, setBallEvent] = useState({});
  const [scorecard, setScorecard] = useState({});
  const socketRef = useRef(null);
  const reconnectAttemptsRef = useRef(0);
  const maxReconnectAttempts = 5;

  useEffect(() => {
    if (!socketUrl) return;

    const connectSocket = () => {
      if (socketRef.current?.connected) return;

      socketRef.current = io(socketUrl, {
        reconnection: true,
        reconnectionAttempts: maxReconnectAttempts,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        timeout: 20000,
        transports: ["websocket"],
        forceNew: true,
      });

      const socket = socketRef.current;

      socket.on("connect", () => {
        console.log("✅ Connected to WebSocket server");
        reconnectAttemptsRef.current = 0;
      });

      socket.on("matchodds", (data) => {
        if (data) setMarkets(data);
      });

      socket.on("fancyodds", (data) => {
        if (data) setFancy(data);
      });

      socket.on("ball_event", (data) => {
        if (data) setBallEvent(data);
      });

      socket.on("scorecard", (data) => {
        if (data) setScorecard(data);
      });

      socket.on("disconnect", (reason) => {
        console.log("🔌 Disconnected from WebSocket server:", reason);
        if (reason === "io server disconnect") {
          // Reconnect manually if server disconnected
          setTimeout(() => {
            socket.connect();
          }, 1000);
        }
      });

      socket.on("connect_error", (error) => {
        console.error("❌ Connection error:", error.message);
        reconnectAttemptsRef.current++;

        if (reconnectAttemptsRef.current >= maxReconnectAttempts) {
          console.error("Max reconnection attempts reached");
          socket.disconnect();
        }
      });

      socket.on("error", (error) => {
        console.error("❌ WebSocket error:", error);
      });
    };

    connectSocket();

    // Cleanup function
    return () => {
      if (socketRef.current) {
        socketRef.current.removeAllListeners();
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [socketUrl]);

  return { markets, fancy, ballEvent, scorecard };
};

// Custom hook for data fetching with cleanup
const useDataFetching = (fetchFn, dependencies = [], interval = null) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const isMountedRef = useRef(true);

  const fetchData = useCallback(async () => {
    if (!isMountedRef.current) return;

    setLoading(true);
    setError(null);

    try {
      const response = await fetchFn();
      if (response?.success && isMountedRef.current) {
        setData(response?.data);
      }
    } catch (err) {
      if (isMountedRef.current) {
        setError(err.message);
        console.error(`Error in ${fetchFn.name}:`, err);
      }
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  }, [fetchFn]);

  useEffect(() => {
    isMountedRef.current = true;

    fetchData();

    let intervalId;
    if (interval) {
      intervalId = setInterval(fetchData, interval);
    }

    return () => {
      isMountedRef.current = false;
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [fetchData, interval, ...dependencies]);

  return { data, loading, error, refetch: fetchData };
};

const AppContext = ({ children }) => {
  // Determine environment

  // const IMG_URL = "http://127.0.0.1:1802";
  // const SOCKET = "ws://127.0.0.1:1802";

  // const IMG_URL = "http://192.168.16.53:1802";
  // const SOCKET = "ws://192.168.16.53:1802";

  // const IMG_URL = "http://192.168.16.38:1802";
  // const SOCKET = "ws://192.168.16.38:1802";

  // # # Production Environment Variable

  const IMG_URL = "https://bet247.star555.in";
  const SOCKET = "wss://bet247.star555.in";

  // State declarations
  const [ChangePass, setChangePass] = useState(false);
  const [User, setUser] = useState({});
  const [manageGeneral, setManageGeneral] = useState({});
  const [LiveAmount, setLiveAmount] = useState([]);
  const [AppSetup, setAppSetup] = useState({});
  const [Games, setGames] = useState([]);
  const [LiveGamesMatches, setLiveGamesMatches] = useState([]);
  const [
    MarketAnalysisLiveGamesMatche,
    setMarketAnalysisLiveGamesMatches,
  ] = useState([]);
  const [matched_bets, setmatched_bets] = useState([]);
  const [unmatched_bets, setunmatched_bets] = useState([]);

  // Loading states
  const [loadingStates, setLoadingStates] = useState({
    user: false,
    settings: false,
    games: false,
    liveMatches: false,
    bets: false,
  });

  // Get token directly
  const token = Cookies.get(CookiesName);

  // Socket connection
  const { markets, fancy, ballEvent, scorecard } = useSocketConnection(SOCKET);

  // Data fetching functions with cleanup
  const GETUser = useCallback(async () => {
    if (!token) return null;

    setLoadingStates((prev) => ({ ...prev, user: true }));
    try {
      const response = await AdminDetails();
      if (response?.success) {
        setChangePass(response?.data?.user_details?.change_password || false);
        setUser(response?.data || {});
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching user:", error);
      throw error;
    } finally {
      setLoadingStates((prev) => ({ ...prev, user: false }));
    }
  }, [token]);

  const fetchSettings = useCallback(async () => {
    setLoadingStates((prev) => ({ ...prev, settings: true }));
    try {
      const response = await Settings();
      if (response?.success) {
        setAppSetup(response?.data || {});
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
      throw error;
    } finally {
      setLoadingStates((prev) => ({ ...prev, settings: false }));
    }
  }, []);

  const fetchAllGames = useCallback(async () => {
    setLoadingStates((prev) => ({ ...prev, games: true }));
    try {
      const response = await AllGames();
      if (response?.success) {
        setGames(response?.data || []);
      }
    } catch (error) {
      console.error("Error fetching games:", error);
      throw error;
    } finally {
      setLoadingStates((prev) => ({ ...prev, games: false }));
    }
  }, []);

  const fetchLiveMatches = useCallback(async () => {
    setLoadingStates((prev) => ({ ...prev, liveMatches: true }));
    try {
      const [liveResponse, analysisResponse] = await Promise.allSettled([
        OnlyLiveGamesMatches(),
        MarketAnalysisLiveGamesMatches(),
      ]);

      if (liveResponse.status === "fulfilled" && liveResponse.value?.success) {
        setLiveGamesMatches(liveResponse.value?.data || []);
      }

      if (
        analysisResponse.status === "fulfilled" &&
        analysisResponse.value?.success
      ) {
        setMarketAnalysisLiveGamesMatches(analysisResponse.value?.data || []);
      }
    } catch (error) {
      console.error("Error fetching live matches:", error);
    } finally {
      setLoadingStates((prev) => ({ ...prev, liveMatches: false }));
    }
  }, []);

  const fetchBets = useCallback(async () => {
    if (!User?.user_details?.id) return;

    setLoadingStates((prev) => ({ ...prev, bets: true }));
    try {
      const [matched, unmatched, managegeneral] = await Promise.allSettled([
        GetAll(),
        GetAllUnmatchBets(),
        ManageSettlementList(),
      ]);

      if (matched.status === "fulfilled" && matched.value?.data) {
        setmatched_bets(matched.value.data);
      }

      if (unmatched.status === "fulfilled" && unmatched.value?.data) {
        setunmatched_bets(unmatched.value.data);
      }
      if (managegeneral.status === "fulfilled" && managegeneral.value?.data) {
        setManageGeneral(managegeneral.value?.data || {});
      }
    } catch (error) {
      console.error("Error fetching bets:", error);
    } finally {
      setLoadingStates((prev) => ({ ...prev, bets: false }));
    }
  }, [User?.user_details?.id]);

  // Initial data fetching
  useEffect(() => {
    const abortController = new AbortController();

    const initializeData = async () => {
      try {
        await Promise.all([
          GETUser(),
          fetchSettings(),
          fetchAllGames(),
          fetchLiveMatches(),
        ]);
      } catch (error) {
        console.error("Error initializing data:", error);
      }
    };

    initializeData();

    return () => {
      abortController.abort();
    };
  }, [GETUser, fetchSettings, fetchAllGames, fetchLiveMatches]);

  // Polling intervals with cleanup
  useEffect(() => {
    const intervals = [];

    if (token) {
      const userInterval = setInterval(() => {
        GETUser();
      }, 3000);
      intervals.push(userInterval);
    }

    const gamesInterval = setInterval(() => {
      fetchAllGames();
    }, 10000);
    intervals.push(gamesInterval);

    const liveMatchesInterval = setInterval(() => {
      fetchLiveMatches();
    }, 10000);
    intervals.push(liveMatchesInterval);

    return () => {
      intervals.forEach(clearInterval);
    };
  }, [token, GETUser, fetchAllGames, fetchLiveMatches]);

  // Fetch bets when user is available
  useEffect(() => {
    if (User?.user_details?.id) {
      fetchBets();

      // Optional: Set up polling for bets
      const betsInterval = setInterval(fetchBets, 15000);
      return () => clearInterval(betsInterval);
    }
  }, [User, fetchBets]);
  // console.log("manageGeneral", manageGeneral);

  // Memoize context value
  const contextValue = useMemo(
    () => ({
      // Constants
      IMG_URL,
      Cookies,

      // App Data
      AppSetup,
      User,
      Games,
      LiveGamesMatches,
      MarketAnalysisLiveGamesMatche,

      // Socket Data
      Markets: markets,
      Fancy: fancy,
      BallEvent: ballEvent,
      Scorecard: scorecard,

      // User Data
      ChangePass,
      matched_bets,
      unmatched_bets,
      LiveAmount,

      // Setters
      setUser,
      setLiveAmount,
      setChangePass,

      // Actions
      refreshUser: GETUser,
      refreshGames: fetchAllGames,
      refreshLiveMatches: fetchLiveMatches,
      refreshBets: fetchBets,

      // Loading States
      loadingStates,

      // Utilities
      isAuthenticated: !!token,
      hasUser: !!User?.user_details?.id,
      //
      GETUser,
      //
      manageGeneral,
    }),
    [
      IMG_URL,
      AppSetup,
      User,
      Games,
      LiveGamesMatches,
      MarketAnalysisLiveGamesMatche,
      markets,
      fancy,
      ballEvent,
      scorecard,
      ChangePass,
      matched_bets,
      unmatched_bets,
      LiveAmount,
      loadingStates,
      token,
      GETUser,
      fetchAllGames,
      fetchLiveMatches,
      fetchBets,
    ],
  );

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

// Custom hook for using context with type checking
export const useAppContext = () => {
  const context = React.useContext(Context);
  if (context === undefined) {
    throw new Error("useAppContext must be used within an AppContext Provider");
  }
  return context;
};

export default AppContext;
